import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Field } from 'redux-form';
import * as styles from './OMRadioButtons.scss';

class OMRadioButtons extends Component {
  state = {
    doReset: false
  };

  componentWillReceiveProps = ({ doReset }) => {
    if (doReset && doReset !== this.props.doReset) {
      this.setState({ doReset: true });
    } else {
      this.setState({ doReset: false });
    }
  };

  render() {
    return (
      <div className={cx('fieldset', styles.radioWrapper, this.props.className, { not_valid: this.props.isInvalid })}>
        { this.props.values.map(({ value, label }) => (
          <div className="radio" key={value}>
            <label htmlFor={value}>
              <Field
                name={this.props.name}
                component="input"
                type="radio"
                value={value}
                id={value}
              />
              <span>
                <span>{ label }</span>
              </span>
            </label>
          </div>
        )) }
      </div>
    );
  }
}

OMRadioButtons.propTypes = {
  values: PropTypes.array,
  name: PropTypes.string,
  doReset: PropTypes.bool,
  isInvalid: PropTypes.bool,
  className: PropTypes.string
};

export default OMRadioButtons;
